import { ACCESSORIES_SUB_TYPES } from "constants/products";
import { ACCESSORY_PRODUCT_TYPE, PRODUCT_TYPES } from "constants/sales";
import { Product } from "services/types/products.type";

// Accessories are labelled by subtype ("Dome", "Receiver"); every other type is
// labelled by the type itself.
//
// Written as an allowlist of Hearing Aid / Supply / Service / Fee, it silently
// dropped Cochlear Implant: the catalog list showed "--" for one until you opened
// the inline edit row, which reads `PRODUCT_TYPES` directly. Inverted so any type
// present in `PRODUCT_TYPES` resolves, and only a missing/unknown type falls back —
// a type added to the enum now works here without a second edit.
export const getProductTypeText = (product: Product) => {
  const {
    master_product: { type, subtype }
  } = product;

  if (type === ACCESSORY_PRODUCT_TYPE) {
    return ACCESSORIES_SUB_TYPES.getFromCode(subtype);
  }

  return PRODUCT_TYPES.getFromCode(type) || "--";
};

export const isProductEditable = (
  canEdit: boolean,
  isSunoAdminOrBusinessOwner: boolean,
  product_lock?: boolean
) => {
  return canEdit && (!Boolean(product_lock) || isSunoAdminOrBusinessOwner);
};
